module.exports = __webpack_public_path__ + "media/images/auto-grow-card-member-c8972fb9.png";